function setCookie(name, value, days) {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days*24*60*60*1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}

if ( !getCookie('cookies_consent') ) {
	var cookieNotice = document.createElement('div');

	cookieNotice.id = 'cookie-notice';
	cookieNotice.classList.add('c-cookieNotice');
	cookieNotice.innerHTML = '<p>Używam cookies oraz innych narzędzi, by ulepszyć Twoje doświadczenia wyszukiwania, pokazywać spersonalizowane treści, analizować ruch na stronie oraz lepiej zrozumieć skąd użytkownicy trafiają na moją stronę. Więcej informacji na ten temat możesz znaleźć w dziale <a href="https://www.theblondtravels.com/cookie-policy" target="_blank" rel="noopener noreferrer">Polityka cookie</p> oraz <a href="https://www.theblondtravels.com/privacy-policy/" target="_blank" rel="noopener noreferrer">Polityka prywatności</a>.</p><p>Wybierając opcję Akceptuję zgadzasz się na wykorzystywanie cookies oraz innych narzędzi śledzących ruch na stronie.</p><button class="c-cookieNotice__acceptButton" id="accept-cookies" type="button">Akceptuję</button>';
	document.body.appendChild(cookieNotice);

	document.getElementById('accept-cookies').addEventListener('click', function() {
		setCookie('cookies_consent', true, 90);
		cookieNotice.remove();
	});
}
